export default {
  roles: state => state.roles,
  accounts: state => state.accounts,
  errors: state => state.errors,
  allRolesPermissions: state => state.allRolesPermissions,
  allPermissions: state => state.allPermissions
};
